import { Auth } from 'aws-amplify';

const logout = (options = {}) => {
  return Auth.signOut(options).catch(error => {
    if (process.env.NODE_ENV === 'development')
      console.error('Logout error:', error);
    return Auth.signOut();
  });
};

export default logout;
